const jobs = [
  {
    "id": "1",
    "title": "Quantitative Developer",
    "location": "Singapore",
    "type": "Full-time",
    "tags": ["Python", "Algorithms", "Math"],
    "updated_at": "2026-01-14",
    "description": "Work closely with traders to implement and optimize high-frequency trading algorithms. You will bridge the gap between theoretical models and production code, develop robust backtesting frameworks to validate strategy performance, and build risk measurement and management systems to monitor exposures and ensure portfolio resilience.",
    "requirements": [
      "Solid financial market knowledge and risk management experience.",
      "Strong background in Mathematics, Statistics, or Physics.",
      "Proficiency in Python (NumPy, Pandas), Rust, or C++.",
      "Proficiency in machine learning techniques.",
      "Fluent in English; Mandarin is a plus."
    ]
  }
];

export default jobs;
